import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';
import { CmsComponent } from './cms.component';
import { FormsModule } from '@angular/forms';
import { RegistrationModule } from 'src/app/popupModel/registration/registration.module';
import { CmsviewcoursesModule } from 'src/app/Components/cmsviewcourses/cmsviewcourses.module';
import { CareersformModule } from './careersform/careersform.module';
import { ContactUsformModule } from './contact-usform/contact-usform.module';
import { SchoolTieUpProgramModule } from './school-tie-up-program/school-tie-up-program.module';
import { FranchiseeModule } from './franchisee/franchisee.module';
import { TabletLearningProgramModule } from './tablet-learning-program/tablet-learning-program.module';
import { IcatModule } from './icat/icat.module';
import { JuniorhackerModule } from './juniorhacker/juniorhacker.module';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SiblingLinkComponent } from 'src/app/Components/sibling-link/sibling-link.component';
import { SiblingLinkModule } from 'src/app/Components/sibling-link/sibling-link.module';

@NgModule({
  declarations: [CmsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([
      { path: '', component: CmsComponent },
      { path: ':url1/:url2/:url3/:url4', component: CmsComponent },
      { path: ':url1/:url2/:url3', component: CmsComponent },
      { path: ':url1/:url2', component: CmsComponent },
      { path: ':url1', component: CmsComponent },
    ]),
    SharedModule,
    FormsModule,
    RegistrationModule,
    CmsviewcoursesModule,
    SiblingLinkModule,
    // CareersformModule,
    // ContactUsformModule,
    // SchoolTieUpProgramModule,
    // FranchiseeModule,
    // TabletLearningProgramModule,
    // IcatModule,
    // JuniorhackerModule,
    NgbModalModule
  ],
  providers: [NgbActiveModal]
})
export class CMSModule { }
